import './index.less';
// style dependencies
import '../../tag/style';
import '../../button/style';
import '../../tabs/style';
import '../../select/style';
